import { useEffect } from 'react';
import { LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/auth-store';
import { useAppStore } from '@/stores/app-store';
import { useOrgJoinStore, getChoiceKey, useOrgSetupGateVisible } from '@/stores/org-join-store';
import { SharedAdminChooser } from '@/components/auth/shared-admin-chooser';
import { AnimatedHeight } from '@/components/ui/animated-height';

export function OrgSetupGate({ isMini }: { isMini?: boolean }) {
  const uid = useAuthStore((s) => s.user?.uid);
  const userEmail = useAuthStore((s) => s.user?.email);
  const signOut = useAuthStore((s) => s.signOut);
  const extensionName = useAppStore((s) => s.extensionName);
  const choiceKey = useOrgJoinStore((s) => s.choiceKey);
  const loadMyChoice = useOrgJoinStore((s) => s.loadMyChoice);
  const visible = useOrgSetupGateVisible();

  useEffect(() => {
    if (uid && extensionName && choiceKey !== getChoiceKey(uid, extensionName)) {
      loadMyChoice();
    }
  }, [uid, extensionName, choiceKey, loadMyChoice]);

  if (!visible) return null;

  return (
    <div
      className={
        isMini
          ? 'fixed inset-0 z-[60] flex flex-col bg-background overflow-y-auto scrollbar-none'
          : 'fixed inset-0 z-[60] flex items-center justify-center bg-background/80 backdrop-blur-sm p-4'
      }
    >
      <div
        className={
          isMini
            ? 'relative w-full flex-1 flex flex-col bg-card'
            : 'relative w-full max-w-xl max-h-full overflow-y-auto scrollbar-none rounded-lg border border-border bg-card shadow-lg'
        }
      >
        <div className={isMini ? 'flex-1 px-5 py-6' : 'px-8 pt-8 pb-6'}>
          <AnimatedHeight className="-mx-1 px-1">
            <SharedAdminChooser />
          </AnimatedHeight>
        </div>
        <div className="flex items-center justify-between border-t border-border/50 bg-muted/50 px-8 py-3">
          <span className="truncate text-[11px] text-muted-foreground">{userEmail}</span>
          <button
            onClick={() => signOut()}
            className="ml-2 flex shrink-0 items-center gap-1 text-[11px] text-muted-foreground transition-colors hover:text-destructive"
          >
            <LogOut className="h-3 w-3" />
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
